<!-- FILTER VERSION -->
<div *ngIf="!disabled && size == 's' && showQueryDirection" class="tdt-query-cnt">
    <!-- BEFORE -->
    <div *ngIf="selQueryDirection != 'lt'" class="tdt-ico-direction" (click)="onSelectDirection('lt')" [title]="'grid.dateBefore' | translate">
        <i class="fal fa-chevron-left tdt-ico-query"></i>
    </div>
    <!-- BEFORE SELECTED -->
    <div *ngIf="selQueryDirection == 'lt'" class="tdt-ico-direction-selected">
        <i  class="fal fa-chevron-left tdt-ico-query"></i>
    </div>
    
    <!-- EQUALS -->
    <div *ngIf="selQueryDirection != 'eq'" class="tdt-ico-direction" (click)="onSelectDirection('eq')" [title]="'grid.dateEquals' | translate">
        <i class="fal fa-equals tdt-ico-query" ></i>
    </div>
    <!-- EQUALS SELECTED -->
    <div *ngIf="selQueryDirection == 'eq'" class="tdt-ico-direction-selected">
        <i class="fal fa-equals tdt-ico-query"></i>
    </div>

    <!-- AFTER -->
    <div *ngIf="selQueryDirection != 'gt'" class="tdt-ico-direction"  (click)="onSelectDirection('gt')" [title]="'grid.dateAfter' | translate">
        <i class="fal fa-chevron-right tdt-ico-query"></i>
    </div>
    <!-- AFTER SELECTED -->
    <div *ngIf="selQueryDirection == 'gt'" class="tdt-ico-direction-selected">
        <i class="fal fa-chevron-right tdt-ico-query"></i>
    </div>

     <!-- BETWEEN -->
     <div *ngIf="selQueryDirection != 'ltgt'" class="tdt-ico-direction"  (click)="onSelectDirection('ltgt')" [title]="'grid.between' | translate">
        <i class="fal fa-arrows-alt-h tdt-ico-query"></i>
    </div>
    <!-- BETWEEN SELECTED -->
    <div *ngIf="selQueryDirection == 'ltgt'" class="tdt-ico-direction-selected">
        <i class="fal fa-arrows-alt-h tdt-ico-query"></i>
    </div>

    <!-- CLEAR -->
    <div *ngIf="selQueryDirection != ''" class="tdt-ico-direction" (click)="onClearDirection()" [title]="'grid.clearDirection' | translate">
        <i class="fal fa-times tdt-ico-query"></i>
    </div>  
    <div *ngIf="selQueryDirection == ''" class="tdt-ico-direction-disabled">
        <i class="fal fa-times tdt-ico-query"></i>
    </div>  
</div>
<div *ngIf="!disabled && size == 's' && selQueryDirection != 'ltgt'" class="tdt-cnt td-cnt-small" [ngClass]="{'no-margin' : noMargin, 'no-min-width': noMinWidth}">
    <input [id]="dateTimeId" [matDatepicker]="pickerFilter" [formControl]="date" (dateChange)="onChangeDate($event)" [disabled]="disabled" class="dp-small-input" readonly="true" 
        [placeholder]="dateFormat.toLowerCase()">
    <i class="fas fa-calendar-day ico-calendar ico-small" (click)="pickerFilter.open()" [id]="'toggle_' + dateTimeId"></i>
    <mat-datepicker #pickerFilter (closed)="onDTClose()" color="primary"></mat-datepicker>
</div>

<div *ngIf="!disabled && size == 's' && selQueryDirection == 'ltgt'" class="tdt-cnt td-cnt-small" [ngClass]="{'no-margin' : noMargin, 'no-min-width': noMinWidth}">
    <input [id]="dateTimeId + 'gt'" [matDatepicker]="pickerFilterLt" [formControl]="date" (dateChange)="onChangeDateBetween($event, 'gt')" [disabled]="disabled" class="dp-small-input" readonly="true" 
        [placeholder]="dateFormat.toLowerCase()" [ngClass]="{'tdt-input-error': dateGt.touched && dateGt.status == 'INVALID' }">
    <i class="fas fa-calendar-day ico-calendar ico-small mr-5" style="margin-left: 0.25vw;"  (click)="pickerFilterLt.open()" [id]="'toggle_' + dateTimeId"></i>
    <mat-datepicker #pickerFilterLt (closed)="onDTClose()" color="primary"></mat-datepicker>

    <input [id]="dateTimeId + 'lt'" [matDatepicker]="pickerFilterGt" [formControl]="date" (dateChange)="onChangeDateBetween($event, 'lt')" [disabled]="disabled" class="dp-small-input" readonly="true" 
        [placeholder]="dateFormat.toLowerCase()" [ngClass]="{'tdt-input-error':  dateLt.touched &&  dateLt.status == 'INVALID'}">
    <i class="fas fa-calendar-day ico-calendar ico-small" style="margin-left: 0.25vw;" (click)="pickerFilterGt.open()" [id]="'toggle_' + dateTimeId"></i>
    <mat-datepicker #pickerFilterGt (closed)="onDTClose()" color="primary"></mat-datepicker>
</div>

<!-- SMALL SIZE WITH LABEL 's-label' -->
<div *ngIf="!disabled && size === 's-label'" class="tdt-cnt td-cnt-small" style="flex-direction: column;align-items: normal;justify-content: inherit;"
    [ngClass]="{'no-margin' : noMargin, 'no-min-width': noMinWidth}">
    <span *ngIf="labelText != ''" class="tdt-label" [ngClass]="{'tdt-span-error' : !isValid}">{{labelText}} <span
            *ngIf="isRequired">*</span></span>
    <div style="width: 100%;display: flex;flex-direction: row; align-items: center;justify-content: space-between;">
        <input [id]="dateTimeId" [matDatepicker]="pickerFilter" [formControl]="date" (dateChange)="onChangeDate($event)"
            [disabled]="disabled" class="dp-small-input" readonly="true" [placeholder]="dateFormat.toLowerCase()" [min]="minDate" [max]="maxDate">
        <i class="fas fa-calendar-day ico-calendar ico-small" (click)="pickerFilter.open()"
            [id]="'toggle_' + dateTimeId"></i>
        <mat-datepicker #pickerFilter (closed)="onDTClose()" color="primary"></mat-datepicker>
    </div>
</div>

<!-- NORMAL SIZE -->
<div *ngIf="size != 's' && size != 's-label'" class="tdt-cnt" [ngClass]="{'no-margin' : noMargin, 'no-min-width': noMinWidth}">
    <span *ngIf="labelText != ''" class="tdt-label" [ngClass]="{'tdt-span-error' : !isValid}">{{labelText}} <span *ngIf="isRequired">*</span></span>
    <div style="width: 100%;display: flex;flex-direction: row; align-items: center;justify-content: space-between;">
        <input [id]="dateTimeId" class="tdt-input" [matDatepicker]="picker" [formControl]="date" (focusout)="checkDate()"
            (dateChange)="onChangeDate($event)" [disabled]="disabled" [readOnly]="readOnly" [placeholder]="dateFormat.toLowerCase()" (keydown)="onInputKeyDown($event)" [ngClass]="{'tdt-readonly': readOnly}" [min]="minDate" [max]="maxDate">
        <!-- <mat-datepicker-toggle matIconSuffix [for]="picker" (click)="onDTToggleClick()" [id]="'toggle_' + dateTimeId"></mat-datepicker-toggle> -->
        <i *ngIf="!readOnly" class="fas fa-calendar-day ico-calendar" (click)="picker.open()" [id]="'toggle_' + dateTimeId"></i>
        <mat-datepicker #picker (closed)="onDTClose()" color="primary"></mat-datepicker>
    </div>
</div>

